/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getLearningObject = /* GraphQL */ `
  query GetLearningObject($id: ID!) {
    getLearningObject(id: $id) {
      id
      title
      description
      areaId
      areaNames
      course
      code
      type
      published
      contents {
        items {
          id
          learningObjectId
          contentId
          learningObject {
            id
            title
            description
            areaId
            areaNames
            course
            code
            type
            published
            sortedContentIds
          }
          content {
            id
            title
            url
            posterUrl
          }
          title
          description
          cameraOrbit
          cameraTarget
          fieldOfView
          hotspots {
            nextToken
          }
        }
        nextToken
      }
      sortedContentIds
    }
  }
`;
export const listLearningObjects = /* GraphQL */ `
  query ListLearningObjects(
    $filter: ModelLearningObjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLearningObjects(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        description
        areaId
        areaNames
        course
        code
        type
        published
        contents {
          items {
            id
            learningObjectId
            contentId
            title
            description
            cameraOrbit
            cameraTarget
            fieldOfView
          }
          nextToken
        }
        sortedContentIds
      }
      nextToken
    }
  }
`;
export const getArea = /* GraphQL */ `
  query GetArea($id: ID!) {
    getArea(id: $id) {
      id
      name
      learningObjects {
        items {
          id
          title
          description
          areaId
          areaNames
          course
          code
          type
          published
          contents {
            nextToken
          }
          sortedContentIds
        }
        nextToken
      }
    }
  }
`;
export const listAreas = /* GraphQL */ `
  query ListAreas(
    $filter: ModelAreaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAreas(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        learningObjects {
          items {
            id
            title
            description
            areaId
            areaNames
            course
            code
            type
            published
            sortedContentIds
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getLearningObjectContent = /* GraphQL */ `
  query GetLearningObjectContent($id: ID!) {
    getLearningObjectContent(id: $id) {
      id
      learningObjectId
      contentId
      learningObject {
        id
        title
        description
        areaId
        areaNames
        course
        code
        type
        published
        contents {
          items {
            id
            learningObjectId
            contentId
            title
            description
            cameraOrbit
            cameraTarget
            fieldOfView
          }
          nextToken
        }
        sortedContentIds
      }
      content {
        id
        title
        url
        posterUrl
        learningObjects {
          items {
            id
            learningObjectId
            contentId
            title
            description
            cameraOrbit
            cameraTarget
            fieldOfView
          }
          nextToken
        }
      }
      title
      description
      cameraOrbit
      cameraTarget
      fieldOfView
      hotspots {
        items {
          id
          title
          normal
          cameraOrbit
          cameraTarget
          fieldOfView
          learningObjectContentId
          learningObjectContent {
            id
            learningObjectId
            contentId
            title
            description
            cameraOrbit
            cameraTarget
            fieldOfView
          }
        }
        nextToken
      }
    }
  }
`;
export const listLearningObjectContents = /* GraphQL */ `
  query ListLearningObjectContents(
    $filter: ModelLearningObjectContentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLearningObjectContents(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        learningObjectId
        contentId
        learningObject {
          id
          title
          description
          areaId
          areaNames
          course
          code
          type
          published
          contents {
            nextToken
          }
          sortedContentIds
        }
        content {
          id
          title
          url
          posterUrl
          learningObjects {
            nextToken
          }
        }
        title
        description
        cameraOrbit
        cameraTarget
        fieldOfView
        hotspots {
          items {
            id
            title
            normal
            cameraOrbit
            cameraTarget
            fieldOfView
            learningObjectContentId
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getContent = /* GraphQL */ `
  query GetContent($id: ID!) {
    getContent(id: $id) {
      id
      title
      url
      posterUrl
      learningObjects {
        items {
          id
          learningObjectId
          contentId
          learningObject {
            id
            title
            description
            areaId
            areaNames
            course
            code
            type
            published
            sortedContentIds
          }
          content {
            id
            title
            url
            posterUrl
          }
          title
          description
          cameraOrbit
          cameraTarget
          fieldOfView
          hotspots {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const listContents = /* GraphQL */ `
  query ListContents(
    $filter: ModelContentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        url
        posterUrl
        learningObjects {
          items {
            id
            learningObjectId
            contentId
            title
            description
            cameraOrbit
            cameraTarget
            fieldOfView
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getHotspot = /* GraphQL */ `
  query GetHotspot($id: ID!) {
    getHotspot(id: $id) {
      id
      title
      normal
      cameraOrbit
      cameraTarget
      fieldOfView
      learningObjectContentId
      learningObjectContent {
        id
        learningObjectId
        contentId
        learningObject {
          id
          title
          description
          areaId
          areaNames
          course
          code
          type
          published
          contents {
            nextToken
          }
          sortedContentIds
        }
        content {
          id
          title
          url
          posterUrl
          learningObjects {
            nextToken
          }
        }
        title
        description
        cameraOrbit
        cameraTarget
        fieldOfView
        hotspots {
          items {
            id
            title
            normal
            cameraOrbit
            cameraTarget
            fieldOfView
            learningObjectContentId
          }
          nextToken
        }
      }
    }
  }
`;
export const listHotspots = /* GraphQL */ `
  query ListHotspots(
    $filter: ModelHotspotFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHotspots(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        normal
        cameraOrbit
        cameraTarget
        fieldOfView
        learningObjectContentId
        learningObjectContent {
          id
          learningObjectId
          contentId
          learningObject {
            id
            title
            description
            areaId
            areaNames
            course
            code
            type
            published
            sortedContentIds
          }
          content {
            id
            title
            url
            posterUrl
          }
          title
          description
          cameraOrbit
          cameraTarget
          fieldOfView
          hotspots {
            nextToken
          }
        }
      }
      nextToken
    }
  }
`;
export const searchLearningObjects = /* GraphQL */ `
  query SearchLearningObjects(
    $filter: SearchableLearningObjectFilterInput
    $sort: SearchableLearningObjectSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchLearningObjects(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        areaId
        areaNames
        course
        code
        type
        published
        contents {
          items {
            id
            learningObjectId
            contentId
            title
            description
            cameraOrbit
            cameraTarget
            fieldOfView
          }
          nextToken
        }
        sortedContentIds
      }
      nextToken
      total
    }
  }
`;
export const searchAreas = /* GraphQL */ `
  query SearchAreas(
    $filter: SearchableAreaFilterInput
    $sort: SearchableAreaSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchAreas(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        learningObjects {
          items {
            id
            title
            description
            areaId
            areaNames
            course
            code
            type
            published
            sortedContentIds
          }
          nextToken
        }
      }
      nextToken
      total
    }
  }
`;
export const searchLearningObjectContents = /* GraphQL */ `
  query SearchLearningObjectContents(
    $filter: SearchableLearningObjectContentFilterInput
    $sort: SearchableLearningObjectContentSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchLearningObjectContents(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        learningObjectId
        contentId
        learningObject {
          id
          title
          description
          areaId
          areaNames
          course
          code
          type
          published
          contents {
            nextToken
          }
          sortedContentIds
        }
        content {
          id
          title
          url
          posterUrl
          learningObjects {
            nextToken
          }
        }
        title
        description
        cameraOrbit
        cameraTarget
        fieldOfView
        hotspots {
          items {
            id
            title
            normal
            cameraOrbit
            cameraTarget
            fieldOfView
            learningObjectContentId
          }
          nextToken
        }
      }
      nextToken
      total
    }
  }
`;
export const searchContents = /* GraphQL */ `
  query SearchContents(
    $filter: SearchableContentFilterInput
    $sort: SearchableContentSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchContents(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        url
        posterUrl
        learningObjects {
          items {
            id
            learningObjectId
            contentId
            title
            description
            cameraOrbit
            cameraTarget
            fieldOfView
          }
          nextToken
        }
      }
      nextToken
      total
    }
  }
`;
export const searchHotspots = /* GraphQL */ `
  query SearchHotspots(
    $filter: SearchableHotspotFilterInput
    $sort: SearchableHotspotSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchHotspots(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        normal
        cameraOrbit
        cameraTarget
        fieldOfView
        learningObjectContentId
        learningObjectContent {
          id
          learningObjectId
          contentId
          learningObject {
            id
            title
            description
            areaId
            areaNames
            course
            code
            type
            published
            sortedContentIds
          }
          content {
            id
            title
            url
            posterUrl
          }
          title
          description
          cameraOrbit
          cameraTarget
          fieldOfView
          hotspots {
            nextToken
          }
        }
      }
      nextToken
      total
    }
  }
`;
